import { Fragment, useEffect, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import { getPayslip, listPayroll, salaryRegister } from "../../../services/payroll";
import { academyusergetdetail } from "../../../services/admin";
import { exportPDF, exportExcel } from "../accounts/exportUtils";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const MONTHS_LABEL = ["","January","February","March","April","May","June","July","August","September","October","November","December"];

const STATUS_BADGE = { paid: "bg-success", approved: "bg-primary", pending: "bg-secondary" };

const ADMIN_ROLES = ["1", "2"];

export default function SalaryRegister() {
  const role       = localStorage.getItem("Role") || "";
  const uid        = localStorage.getItem("UID")  || "";
  const isAdmin    = ADMIN_ROLES.includes(role);

  const [payrollOptions, setPayrollOptions]     = useState([]);
  const [selectedMonth, setSelectedMonth]       = useState(null);
  const [data, setData]                         = useState(null);
  const [loading, setLoading]                   = useState(false);
  const [payslip, setPayslip]                   = useState(null);
  const [payslipShow, setPayslipShow]           = useState(false);
  const [school, setSchool]                     = useState({ name: "", phone: "", address: "", logoUrl: "" });
  const [selfEmpId, setSelfEmpId]               = useState(null);
  const [selfEmpType, setSelfEmpType]           = useState(null);

  useEffect(() => {
    // School info for payslip PDF header
    academyusergetdetail(uid).then((res) => {
      if (res?.status) {
        const d = res.data.details;
        setSchool({ name: d.academy_name || "", phone: d.phone || "", address: d.address || "", logoUrl: d.logo ? (res.data.path + d.logo) : "" });
      }
    });

    // Payroll month list (admin only — non-admin see all their months automatically)
    if (isAdmin) {
      const temp = new FormData();
      if (role === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");
      listPayroll(temp).then((res) => {
        if (res?.status) {
          setPayrollOptions(res.data.map((p) => ({
            value: p.id,
            label: `${MONTHS_LABEL[p.month]} ${p.year} — ${p.status}`,
          })));
        }
      });
    }

    // Non-admin: uid IS the user_id which is now stored as employee_id in payroll_items
    if (role === "5" || role === "6") {
      const empType = role === "5" ? "teacher" : "worker";
      // Load month list so they can optionally filter
      const mTemp = new FormData();
      listPayroll(mTemp).then((res) => {
        if (res?.status) {
          setPayrollOptions(res.data.map((p) => ({
            value: p.id,
            label: `${MONTHS_LABEL[p.month]} ${p.year} — ${p.status}`,
          })));
        }
      });
      setSelfEmpId(uid);
      setSelfEmpType(empType);
      fetchSelf(uid, empType);
    }
  }, []);

  function fetchSelf(empId, empType, monthId) {
    setLoading(true);
    setData(null);
    const temp = new FormData();
    temp.append("employee_id",   empId);
    temp.append("employee_type", empType);
    if (monthId) temp.append("payroll_month_id", monthId);
    salaryRegister(temp).then((res) => {
      setLoading(false);
      if (res?.status) setData(res.data);
    });
  }

  function handleSearch() {
    if (isAdmin) {
      if (!selectedMonth) return;
      setLoading(true);
      setData(null);
      const temp = new FormData();
      temp.append("payroll_month_id", selectedMonth?.value);
      if (role === "1") temp.append("academy_id", localStorage.getItem("AAcademy") || "");
      salaryRegister(temp).then((res) => {
        setLoading(false);
        if (res?.status) setData(res.data);
      });
    } else {
      // Non-admin: filter their own records by the selected month
      if (selfEmpId && selfEmpType) fetchSelf(selfEmpId, selfEmpType, selectedMonth?.value);
    }
  }

  function handlePayslip(itemId) {
    if (!itemId) return;
    getPayslip(itemId).then((res) => {
      if (res?.status) { setPayslip(res.data); setPayslipShow(true); }
      else toast.error(res?.message || "Failed to load payslip");
    });
  }

  async function toBase64(url) {
    try {
      const res  = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch { return null; }
  }

  async function printPayslip() {
    if (!payslip) return;
    const doc        = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pageW      = doc.internal.pageSize.getWidth();
    const month      = `${MONTHS_LABEL[payslip.payroll_month?.month]} ${payslip.payroll_month?.year}`;
    const primary    = [45, 74, 198];
    doc.setFillColor(...primary);
    doc.rect(0, 0, pageW, 30, "F");
    if (school.logoUrl) {
      const b64 = await toBase64(school.logoUrl);
      if (b64) try { doc.addImage(b64, "PNG", 8, 4, 22, 22); } catch {}
    }
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(15); doc.setFont(undefined, "bold");
    doc.text(school.name || "School", 34, 13);
    doc.setFontSize(8); doc.setFont(undefined, "normal");
    if (school.address) doc.text(school.address, 34, 19, { maxWidth: pageW - 50 });
    if (school.phone)   doc.text(`Ph: ${school.phone}`, 34, 25);
    doc.setFontSize(14); doc.setFont(undefined, "bold");
    doc.text("PAYSLIP", pageW - 10, 18, { align: "right" });
    doc.setFillColor(240, 243, 255);
    doc.rect(0, 30, pageW, 10, "F");
    doc.setTextColor(...primary); doc.setFontSize(10);
    doc.text(`Salary for the month of ${month}`, pageW / 2, 37, { align: "center" });
    doc.setTextColor(40, 40, 40); doc.setFontSize(9);
    const leftX = 14, rightX = pageW / 2 + 5;
    let y = 48;
    doc.setDrawColor(220, 220, 220); doc.setFillColor(250, 250, 252);
    doc.rect(10, 42, pageW - 20, 28, "FD");
    [["Employee Name", payslip.employee_name], ["Employee Code", payslip.employee_code], ["Employee Type", payslip.employee_type], ["Payment Month", month]]
      .forEach(([l, v], i) => { const ry = y + i * 6; doc.setFont(undefined, "bold"); doc.setTextColor(80, 80, 80); doc.text(l + ":", leftX + 2, ry); doc.setFont(undefined, "normal"); doc.setTextColor(30, 30, 30); doc.text(v || "", leftX + 40, ry); });
    [["Bank Name", payslip.bank_name || "—"], ["Account No", payslip.bank_accno || "—"], ["Working Days", String(payslip.total_days)], ["Present Days", String(payslip.present_days)]]
      .forEach(([l, v], i) => { const ry = y + i * 6; doc.setFont(undefined, "bold"); doc.setTextColor(80, 80, 80); doc.text(l + ":", rightX + 2, ry); doc.setFont(undefined, "normal"); doc.setTextColor(30, 30, 30); doc.text(v || "", rightX + 32, ry); });
    const earn = payslip.details?.filter((d) => d.component_type === "earning")   || [];
    const dedu = payslip.details?.filter((d) => d.component_type === "deduction") || [];
    autoTable(doc, {
      startY: 76,
      head: [["Earnings", "Amount", "Deductions", "Amount"]],
      body: Array.from({ length: Math.max(earn.length, dedu.length) }, (_, i) => [
        earn[i]?.component_name || "", earn[i]  ? `₹ ${parseFloat(earn[i].amount).toFixed(2)}`  : "",
        dedu[i]?.component_name || "", dedu[i] ? `₹ ${parseFloat(dedu[i].amount).toFixed(2)}` : "",
      ]),
      foot: [["Gross Salary", `₹ ${parseFloat(payslip.gross_salary).toFixed(2)}`, "Total Deductions", `₹ ${parseFloat(payslip.total_deductions).toFixed(2)}`]],
      headStyles: { fillColor: primary, textColor: 255, fontStyle: "bold", fontSize: 9 },
      footStyles: { fillColor: [230, 235, 255], textColor: primary, fontStyle: "bold", fontSize: 9 },
      bodyStyles: { fontSize: 8 }, alternateRowStyles: { fillColor: [248, 250, 255] },
      columnStyles: { 1: { halign: "right" }, 3: { halign: "right" } },
      margin: { left: 10, right: 10 },
    });
    const finalY = doc.lastAutoTable.finalY + 6;
    doc.setFillColor(...primary); doc.roundedRect(10, finalY, pageW - 20, 12, 2, 2, "F");
    doc.setTextColor(255, 255, 255); doc.setFontSize(11); doc.setFont(undefined, "bold");
    doc.text("Net Salary Payable", 16, finalY + 8);
    doc.text(`₹ ${parseFloat(payslip.net_salary).toFixed(2)}`, pageW - 16, finalY + 8, { align: "right" });
    doc.save(`Payslip_${payslip.employee_name}_${month}.pdf`);
  }

  // Collect unique earning / deduction component names
  const { earningCols, deductionCols } = useMemo(() => {
    const earnSet = new Map(), deduSet = new Map();
    (data?.items || []).forEach((item) =>
      (item.details || []).forEach((d) => {
        if (d.component_type === "earning")   earnSet.set(d.component_name, true);
        if (d.component_type === "deduction") deduSet.set(d.component_name, true);
      })
    );
    return { earningCols: [...earnSet.keys()], deductionCols: [...deduSet.keys()] };
  }, [data]);

  // Flatten items: comp_<name> fields for AgGrid
  const flatItems = useMemo(() => {
    return (data?.items || []).map((item) => {
      const row = { ...item };
      (item.details || []).forEach((d) => { row[`comp_${d.component_name}`] = parseFloat(d.amount) || 0; });
      return row;
    });
  }, [data]);

  // Pinned totals row
  const pinnedBottomRowData = useMemo(() => {
    if (!flatItems.length) return [];
    let gross = 0, dedu = 0, net = 0;
    const row = { employee_name: "TOTAL", employee_code: "", employee_type: "", designation: "", total_days: "", present_days: "" };
    earningCols.forEach((c)   => { row[`comp_${c}`] = flatItems.reduce((a, i) => a + (i[`comp_${c}`] || 0), 0); });
    deductionCols.forEach((c) => { row[`comp_${c}`] = flatItems.reduce((a, i) => a + (i[`comp_${c}`] || 0), 0); });
    flatItems.forEach((i) => { gross += parseFloat(i.gross_salary || 0); dedu += parseFloat(i.total_deductions || 0); net += parseFloat(i.net_salary || 0); });
    row.gross_salary = gross; row.total_deductions = dedu; row.net_salary = net; row.status = "";
    return [row];
  }, [flatItems, earningCols, deductionCols]);

  // Build AgGrid column definitions
  const columnDefs = useMemo(() => {
    const fmt  = (p) => (p.value != null && p.value !== "") ? parseFloat(p.value).toFixed(2) : "";

    const staticLeft = [
      { headerName: "#", valueGetter: (p) => p.node.rowPinned ? "" : p.node.rowIndex + 1,
        width: 60, pinned: "left", cellStyle: { textAlign: "center" } },
      { headerName: "Employee Name", field: "employee_name", width: 180, pinned: "left",
        filter: true, floatingFilter: true,
        cellRenderer: (p) => p.node.rowPinned
          ? <strong style={{ color: "#2d4ac6" }}>{p.value}</strong>
          : p.value },
      { headerName: "Code",        field: "employee_code",  width: 110, resizable: true },
      { headerName: "Type",        field: "employee_type",  width: 100, resizable: true,
        cellRenderer: (p) => p.value
          ? <span className={`badge ${p.value === "teacher" ? "bg-primary" : "bg-info"}`}>{p.value}</span>
          : null },
      { headerName: "Designation", field: "designation",    width: 140, resizable: true },
    ];

    const daysCols = [
      { headerName: "Total Days",   field: "total_days",   width: 100, resizable: true, cellStyle: { textAlign: "center" } },
      { headerName: "Present Days", field: "present_days", width: 110, resizable: true, cellStyle: { textAlign: "center" } },
    ];

    const earnDefs = earningCols.map((c) => ({
      headerName: c, field: `comp_${c}`, width: 130, resizable: true,
      valueFormatter: fmt, cellStyle: { textAlign: "right" },
    }));

    const grossCol = {
      headerName: "Gross Salary", field: "gross_salary", width: 130, resizable: true,
      valueFormatter: fmt,
      cellStyle: (p) => ({ textAlign: "right", fontWeight: 600, color: "#1a3299", background: p.node.rowPinned ? "#dce5ff" : "" }),
    };

    const deduDefs = deductionCols.map((c) => ({
      headerName: c, field: `comp_${c}`, width: 130, resizable: true,
      valueFormatter: fmt, cellStyle: { textAlign: "right", color: "#8b1a1a" },
    }));

    const summaryRight = [
      { headerName: "Total Deductions", field: "total_deductions", width: 140, resizable: true,
        valueFormatter: fmt,
        cellStyle: (p) => ({ textAlign: "right", fontWeight: 600, color: "#8b1a1a", background: p.node.rowPinned ? "#ffe5e5" : "" }) },
      { headerName: "Net Salary", field: "net_salary", width: 130, resizable: true,
        valueFormatter: fmt,
        cellStyle: (p) => ({ textAlign: "right", fontWeight: 700, color: "#145214", background: p.node.rowPinned ? "#d4edda" : "" }) },
      { headerName: "Status", field: "status", width: 110, resizable: true,
        cellRenderer: (p) => p.value
          ? <span className={`badge ${STATUS_BADGE[p.value] || "bg-secondary"}`}>{p.value}</span>
          : null },
      { headerName: "Payslip", valueGetter: (p) => p.data?.id, width: 90, filter: false, resizable: false,
        cellRenderer: (p) => {
          if (p.node.rowPinned) return null;
          const id = p.data?.id;
          if (!id) return null;
          return (
            <a onClick={() => handlePayslip(id)} className="btn-sm btn-info" title="View Payslip">
              <i className="fa fa-file-pdf-o" />
            </a>
          );
        }},
    ];

    return [...staticLeft, ...daysCols, ...earnDefs, grossCol, ...deduDefs, ...summaryRight];
  }, [earningCols, deductionCols, handlePayslip]);

  const title = data
    ? `Salary Register — ${MONTHS_LABEL[data.payroll?.month]} ${data.payroll?.year}`
    : "Salary Register";

  function buildExportData() {
    const cols = [
      "#", "Employee Name", "Code", "Type", "Designation",
      "Total Days", "Present Days",
      ...earningCols, "Gross Salary",
      ...deductionCols, "Total Deductions", "Net Salary", "Status",
    ];
    const rows = flatItems.map((item, idx) => [
      idx + 1, item.employee_name, item.employee_code, item.employee_type, item.designation || "",
      item.total_days, item.present_days,
      ...earningCols.map((c)   => (item[`comp_${c}`] || 0).toFixed(2)),
      parseFloat(item.gross_salary     || 0).toFixed(2),
      ...deductionCols.map((c) => (item[`comp_${c}`] || 0).toFixed(2)),
      parseFloat(item.total_deductions || 0).toFixed(2),
      parseFloat(item.net_salary       || 0).toFixed(2),
      item.status,
    ]);
    if (pinnedBottomRowData.length) {
      const t = pinnedBottomRowData[0];
      rows.push([
        "", "TOTAL", "", "", "", "", "",
        ...earningCols.map((c)   => (t[`comp_${c}`] || 0).toFixed(2)),
        parseFloat(t.gross_salary     || 0).toFixed(2),
        ...deductionCols.map((c) => (t[`comp_${c}`] || 0).toFixed(2)),
        parseFloat(t.total_deductions || 0).toFixed(2),
        parseFloat(t.net_salary       || 0).toFixed(2),
        "",
      ]);
    }
    return { cols, rows };
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Salary Register</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a>Payroll</a></li>
            <li className="breadcrumb-item active" aria-current="page">Salary Register</li>
          </ol>
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">

          {/* Filter card */}
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                {/* Month picker — admin: required; non-admin: optional filter on their own records */}
                <Col xxl={6} lg={6} md={6}>
                  <div className="mb-3">
                    <label className="form-label">
                      Payroll Month
                      {isAdmin
                        ? <span className="text-danger"> *</span>
                        : <span className="text-muted ms-1" style={{ fontSize: "11px" }}>(optional — leave blank to see all months)</span>}
                    </label>
                    <Select
                      className="default-select"
                      placeholder="Select Month"
                      options={payrollOptions}
                      value={selectedMonth}
                      onChange={(e) => { setSelectedMonth(e || null); setData(null); }}
                      isClearable
                    />
                  </div>
                </Col>
                <Col xxl={3} lg={3} md={6}>
                  <div className="mb-3">
                    <label className="form-label">&nbsp;</label>
                    <div>
                      {isAdmin ? (
                        <a
                          onClick={handleSearch}
                          className={`btn btn-success ${!selectedMonth || loading ? "disabled" : ""}`}
                        >
                          {loading ? <><i className="fa fa-spinner fa-spin me-1" />Loading...</> : <><i className="fa fa-search me-1" />Show</>}
                        </a>
                      ) : (
                        <a
                          onClick={handleSearch}
                          className={`btn btn-success ${loading ? "disabled" : ""}`}
                        >
                          {loading ? <><i className="fa fa-spinner fa-spin me-1" />Loading...</> : <><i className="fa fa-filter me-1" />Filter</>}
                        </a>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          {/* Results card */}
          {data && (
            <div className="card custom-card mg-b-20">
              <div className="card-body">

                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <div>
                    <h5 className="mb-0">{title}</h5>
                    <small className="text-muted">
                      {flatItems.length} employee{flatItems.length !== 1 ? "s" : ""}
                      {data.payroll ? ` · Status: ${data.payroll.status}` : ""}
                    </small>
                  </div>
                  <div>
                    <a
                      onClick={() => { const { cols, rows } = buildExportData(); exportPDF(title, cols, rows); }}
                      className="btn btn-danger btn-sm me-2"
                    >
                      <i className="fa fa-file-pdf-o me-1" /> PDF
                    </a>
                    <a
                      onClick={() => { const { cols, rows } = buildExportData(); exportExcel(title, cols, rows); }}
                      className="btn btn-success btn-sm"
                    >
                      <i className="fa fa-file-excel-o me-1" /> Excel
                    </a>
                  </div>
                </div>

                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={flatItems}
                    pinnedBottomRowData={pinnedBottomRowData}
                    paginationPageSize={10}
                    suppressDragLeaveHidesColumns
                  />
                </div>

              </div>
            </div>
          )}

        </div>
      </div>
      {/* Payslip Modal */}
      <Modal show={payslipShow} onHide={() => setPayslipShow(false)} size="lg">
        <Modal.Header>
          <h4>Payslip — {payslip?.employee_name}</h4>
        </Modal.Header>
        <Modal.Body>
          {payslip && (
            <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", overflow: "hidden" }}>
              <div style={{ background: "#2d4ac6", padding: "16px 20px", display: "flex", alignItems: "center", gap: "16px" }}>
                {school.logoUrl && (
                  <img src={school.logoUrl} alt="logo" style={{ height: "52px", width: "52px", objectFit: "contain", background: "#fff", borderRadius: "4px", padding: "2px" }}
                    onError={(e) => { e.target.style.display = "none"; }} />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>{school.name}</div>
                  {school.address && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px", marginTop: "2px" }}>{school.address}</div>}
                  {school.phone   && <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px" }}>Ph: {school.phone}</div>}
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "14px", letterSpacing: "1px" }}>PAYSLIP</div>
                  <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "11px" }}>
                    {MONTHS_LABEL[payslip.payroll_month?.month]} {payslip.payroll_month?.year}
                  </div>
                </div>
              </div>
              <div style={{ background: "#f0f3ff", padding: "12px 20px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 20px", fontSize: "12px" }}>
                {[
                  ["Employee Name", payslip.employee_name],
                  ["Bank Name",     payslip.bank_name    || "—"],
                  ["Employee Code", payslip.employee_code],
                  ["Account No",    payslip.bank_accno   || "—"],
                  ["Employee Type", payslip.employee_type],
                  ["Working Days",  `${payslip.present_days} / ${payslip.total_days}`],
                ].map(([label, value]) => (
                  <div key={label} style={{ display: "flex", gap: "8px" }}>
                    <span style={{ color: "#555", minWidth: "110px", fontWeight: "600" }}>{label}:</span>
                    <span style={{ color: "#222" }}>{value}</span>
                  </div>
                ))}
              </div>
              <div style={{ padding: "16px 20px" }}>
                <table className="table table-bordered table-sm mb-0">
                  <thead style={{ backgroundColor: "#2d4ac6" }}>
                    <tr>
                      <th style={{ color: "#fff" }}>Earnings</th>
                      <th className="text-end" style={{ color: "#fff" }}>Amount</th>
                      <th style={{ color: "#fff" }}>Deductions</th>
                      <th className="text-end" style={{ color: "#fff" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const earn = payslip.details?.filter((d) => d.component_type === "earning")   || [];
                      const dedu = payslip.details?.filter((d) => d.component_type === "deduction") || [];
                      return Array.from({ length: Math.max(earn.length, dedu.length) }, (_, i) => (
                        <tr key={i}>
                          <td>{earn[i]?.component_name || ""}</td>
                          <td className="text-end">{earn[i]  ? `₹ ${parseFloat(earn[i].amount).toFixed(2)}`   : ""}</td>
                          <td>{dedu[i]?.component_name || ""}</td>
                          <td className="text-end">{dedu[i] ? `₹ ${parseFloat(dedu[i].amount).toFixed(2)}` : ""}</td>
                        </tr>
                      ));
                    })()}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: "#e8ecff" }}>
                      <td className="fw-bold" style={{ color: "#2d4ac6" }}>Gross Salary</td>
                      <td className="text-end fw-bold" style={{ color: "#2d4ac6" }}>₹ {parseFloat(payslip.gross_salary).toFixed(2)}</td>
                      <td className="fw-bold" style={{ color: "#2d4ac6" }}>Total Deductions</td>
                      <td className="text-end fw-bold" style={{ color: "#2d4ac6" }}>₹ {parseFloat(payslip.total_deductions).toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div style={{ background: "#2d4ac6", padding: "12px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: "#fff", fontWeight: "bold", fontSize: "14px" }}>Net Salary Payable</span>
                <span style={{ color: "#fff", fontWeight: "bold", fontSize: "18px" }}>₹ {parseFloat(payslip.net_salary).toFixed(2)}</span>
              </div>
              <div style={{ padding: "8px 20px", textAlign: "center", fontSize: "10px", color: "#888", borderTop: "1px solid #dee2e6" }}>
                This is a computer generated payslip and does not require a signature.
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <a onClick={printPayslip} className="btn btn-danger">
            <i className="fa fa-file-pdf-o me-1" /> Download PDF
          </a>
          <a onClick={() => setPayslipShow(false)} className="btn btn-secondary">Close</a>
        </Modal.Footer>
      </Modal>

    </Fragment>
  );
}
